import type CardClient from '@atlaskit/link-provider/client';

import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';

import type { ShortcutsSection_spaceSidebarLinks$key } from '../src/__generated__/ShortcutsSection_spaceSidebarLinks.graphql.ts';
import type { useShortcutsSpaceNavigationQuery_quick } from '../src/useShortcuts.tsx';

type ShortcutsSectionProps = {
	isSpaceAdmin: boolean;
	spaceId: string | null;
	spaceKey: string;
	client?: CardClient | undefined;
} & (
	| {
			links: useShortcutsSpaceNavigationQuery_quick[];
			spaceSidebarLinksFragmentRef?: never;
	  }
	| {
			links?: never;
			spaceSidebarLinksFragmentRef: ShortcutsSection_spaceSidebarLinks$key;
	  }
);

export const ShortcutsSection: LoadableType<ShortcutsSectionProps> = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ShortcutsSection" */ '../src/ShortcutsSection.tsx'
			)
		).ShortcutsSection,
});

export type ShortcutsSectionFragmentKey = ShortcutsSection_spaceSidebarLinks$key;
